module.exports = __webpack_public_path__ + "img/tj.9749373.svg";